// extracted by mini-css-extract-plugin
export var textInput = "_ec-0";